import { alpha, createTheme, lighten, darken } from '@mui/material';
import '@mui/lab/themeAugmentation';
import breakpoints from '../../breakpoints';
import palette from './palette';
import colors from './colors';
import shadows from './shadows';
import customShadows from './customShadows';
import typography from './typography';
import shape from '../../shape';


export const DarkTheme = createTheme({
  // direction: i18n.dir(),
  breakpoints,
  colors,
  alpha: {},
  palette,
  shape,
  typography,
  shadows: shadows(),
  customShadows: customShadows(),

  // components: componentsOverride(),
});
